<template>
    <div class="lh">
        <iframe src="https://open.spotify.com/embed-podcast/episode/451ks5vAzYIID6YIteUK0z" width="100%"
                height="232"
                frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
    </div>
</template>

<script>
    export default {}
</script>


<style scoped>
    .lh {
        line-height: 0;
    }
</style>